// localStorage может быть недоступен (приватный режим, запрет сайта) — всё через try/catch
export const store = {
  get(k: string): string | null { try { return localStorage.getItem(k); } catch { return null; } },
  set(k: string, v: string) { try { localStorage.setItem(k, v); } catch { /* без хранилища — живём до перезагрузки */ } },
  del(k: string) { try { localStorage.removeItem(k); } catch { /* — */ } },
};
